import { FormControl, Grid, InputAdornment, ListItem, MenuItem, Select, SelectChangeEvent, TextField, Typography } from "@mui/material"
import React from "react"
import { appdata } from "../AppData"

type Props = {
  scenarioId: string
  rowIndex: number
  amountDisabled: boolean
  changeRowWallType: Function
  changeRowAmount: Function
}

export default function UIScenarioRow ({scenarioId, rowIndex, amountDisabled, changeRowWallType, changeRowAmount}: Props) {

  const scenario = appdata.getScenario(scenarioId);
  const scenarioRow = scenario.rows[rowIndex];

  //layout grid columns
  const c1 = 6;
  const c2 = 3;
  const c3 = 3;

  const handleChangeRowAmount = (event: React.ChangeEvent<HTMLInputElement> ) => {
    let newAmount = (event.target as HTMLInputElement).value;
    changeRowAmount( rowIndex, newAmount);
  };

  const handleChangeRowWallType = (event: SelectChangeEvent) => {
    let newWallTypeId = (event.target as HTMLInputElement).value
    changeRowWallType( rowIndex, newWallTypeId );
  };

  const getSelectValue = () => {
    let wTypeId = scenarioRow.wTypeId
    if (appdata.wallTypes.has(wTypeId)) {
      return wTypeId
    }
    else {
      return ''
    }
  }
  
  return (
    <ListItem disablePadding key={scenarioRow.guid}>
      <Grid container alignItems={'center'}>
        <Grid item xs={c1}>
          <Select size="small" fullWidth
            name='selectedWallTypeId'
            value={getSelectValue()}
            onChange={handleChangeRowWallType}
          >
            {appdata.getWallTypeArray().map( wt => (
              <MenuItem key={wt.guid} value={wt.guid}>{`${wt.name} (${wt.gwpsf.toFixed(2)} kgCO2e/sf)`}</MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={c2}>
          <FormControl variant="filled" fullWidth>
            <TextField
              name='amount'
              placeholder='enter amount'
              value={scenarioRow.amount}
              type='number'
              size='small'
              disabled={amountDisabled}
              onChange={handleChangeRowAmount}
              InputProps={{
                endAdornment: <InputAdornment position="end">
                  { scenario.calcMethod === 'sqft'? 'SF' : '%'}
                </InputAdornment>
              }}
            /> 
          </FormControl>
        </Grid>
        <Grid item xs={c3} display='flex' justifyContent={'right'} >
          <Typography className="h3">{(scenarioRow.gwp / 1000).toFixed(2)}</Typography>
        </Grid>
      </Grid>
    </ListItem>
  )


}